import {putRequest} from "./request";

export const setIsSubscribed = async (userId: number): Promise<any> => {
  return await putRequest<any>(`users/${userId}/subscription`, {}).then(
    (res) => res.data,
  );
};